import React, { useEffect } from "react";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import Card from "../../components/shared/Card/Card";
import { CustomerList } from "../../components/dashboard/CustomerList";
import useCustomers from "../../data/Customer/useCustomers";
import LoadingWheel from "../../components/shared/LoadingWheel";

export default function Dashboard() {
  const { setInfo } = usePageNameContext();
  const { customers } = useCustomers();

  useEffect(() => {
    setInfo({
      name: "Dashboard",
      desc: "View stats for the Wilma software solution.",
      pageTitle: "Dashboard",
    });
  }, []);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
        <Card title="Active Customers">
          <div className="flex items-center justify-center py-5">
            {customers.isLoading ? (
              <div className="flex items-center py-6">
                <LoadingWheel />
              </div>
            ) : (
              <p className="text-8xl m-0 -mt-4">{customers.data?.length}</p>
            )}
          </div>
        </Card>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2">
        <Card title="Recently Viewed Customers">
          <div className="px-4">
            {customers.isLoading ? (
              <div className="py-8">
                <LoadingWheel />
              </div>
            ) : (
              <CustomerList customers={customers.data!} />
            )}
          </div>
        </Card>
      </div>
    </div>
  );
}
